export default {
  id: 'rsrc.url',
  name: 'rsrc.url',
  displayName: 'URL',
  valueType: 'string',
  objectType: 'rsrc',
  placement: {
    group: []
  },
  get: obj => {
    if (obj?.type?.startsWith('image')) {
      return obj.data?.url;
    }
    return null;
  },
  sourceOptions: {
    sortable: false
  }
};